import { render, staticRenderFns } from "./Projetos.vue?vue&type=template&id=59c2bf6e&scoped=true"
import script from "./Projetos.vue?vue&type=script&lang=js"
export * from "./Projetos.vue?vue&type=script&lang=js"
import style0 from "./Projetos.vue?vue&type=style&index=0&id=59c2bf6e&prod&scoped=true&lang=css"
import style1 from "./Projetos.vue?vue&type=style&index=1&id=59c2bf6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c2bf6e",
  null
  
)

export default component.exports